import {
  Grid,
  Container,
  makeStyles,
  Box,
  CircularProgress,
  TextField,
  InputAdornment,
  TablePagination,
} from "@material-ui/core";
import { Drawer, SimpleToolbar } from "../../../../components";
import { useDrawer } from "../../../../hooks";
import { AuthContext } from "../../../../context";
import { useContext, useEffect, useState } from "react";
import DoctorsRefillCategoryTable from "../../../../components/refill/doctors-refill-table";
import { useDoctorsRefillCategories } from "../../../../hooks/useDoctorsRefillCategories";
import { SearchRounded } from "@material-ui/icons";
import { useDebounce } from "../../../../hooks/useDebounce";

export default function DoctorsRefillCategoryScreen() {
  const {
    loading,
    doctors: doctorsRefillCategories,
    changeLimit,
    changePage,
    changeRegex,
    page,
    limit,
    count,
  } = useDoctorsRefillCategories();
  const [localRegex, setLocalRegex] = useState("");
  const regexDebounced = useDebounce(localRegex, 500);
  const { authState } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const classes = useStyles();
  useEffect(() => {
    changeRegex(regexDebounced);
  }, [regexDebounced]);

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              onFilter={(toFilter) => {}}
              noSearchBar
            />
          </Container>
          <Container maxWidth={"lg"} component={"main"}>
            <Box>
              <TextField
                disabled={loading}
                value={localRegex}
                variant="outlined"
                size="small"
                onChange={(e) => setLocalRegex(e.target.value)}
                fullWidth
                className={classes.searchBar}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchRounded />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            {loading || !doctorsRefillCategories ? (
              <Box display={"flex"} justifyContent={"center"} marginTop={2}>
                <CircularProgress />
              </Box>
            ) : (
              <DoctorsRefillCategoryTable />
            )}
            <Box display="flex" justifyContent={"end"}>
              <TablePagination
                labelRowsPerPage="Cant."
                component="div"
                count={count}
                onRowsPerPageChange={(e) => {
                  changeLimit(e.target.value);
                }}
                onPageChange={(e, page) => changePage(page + 1)}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                className={classes.pagination}
              />
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    "& main": {
      flexGrow: 1,
    },
    "& .MuiPaper-root": {
      boxShadow: "none !important",
    },
  },
  searchBar: {
    marginTop: 8,
    "& fieldset": {
      borderRadius: 24,
    },
  },
}));
